exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spinner[data-v-522545ae] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 100%;\n  border: 10px solid rgba(255, 255, 255, 0.2);\n  -webkit-animation: circle-2-spin-data-v-522545ae 1s infinite linear;\n          animation: circle-2-spin-data-v-522545ae 1s infinite linear;\n}\n@-webkit-keyframes circle-2-spin-data-v-522545ae {\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes circle-2-spin-data-v-522545ae {\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-522545ae","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-loading-spinner/src/components/Circle2.vue
// module id = 9oH4
// module chunks = 0